/* eslint-disable @typescript-eslint/no-redeclare */
import Link from 'next/link';
import { styled } from '@mui/material';
import Image from 'next/image';
import { useSelector, AppState } from '../../../../store/Store';

function Logo() {
  const customizer = useSelector((state: AppState) => state.customizer);
  const LOGO_WIDTH = 168;
  const LOGO_HEIGHT = customizer.activeMode === 'dark' ? 60 : 36;
  const LinkStyled = styled(Link)(() => ({
    height: customizer.isCollapse ? '34px' : `${LOGO_HEIGHT}px`,
    width: customizer.isCollapse ? '34px' : '168px',
    overflow: 'hidden',
    display: 'block',
    textDecoration: 'none',
    margin: '0 auto',
  }));

  return (
    <LinkStyled href="/dashboard">
      {customizer.isCollapse ? (
        <Image
          src="/images/logos/agentiza-icon.png"
          alt="agentiza-icon"
          width={34}
          height={34}
          priority
        />
      ) : (
        <Image
          src={customizer.activeMode === 'dark' ? '/images/logos/Agentiza-BL.png' : '/images/logos/agentiza-logo.png'}
          alt="agentiza-logo"
          width={LOGO_WIDTH}
          height={LOGO_HEIGHT}
          priority
        />
      )}
    </LinkStyled>
  );
}

export default Logo;
